'use client';

import { auth0 } from '@ria-client/auth0';
import { useIdentity } from '@ria-client/hooks/useIdentity';
import { useAnalytics } from '@ria-client/segment/Analytics';
import { useAnalyticsPageView } from '@ria-client/segment/Analytics/AnalyticsPageView';
import { getCleanLocationHref } from '@ria-client/segment/Analytics/urlUtils';
import { Button } from '@ria-client/tw-shadcn/components/button';

export function ReviewSignUpBanner() {
  const { pageViewId, pageName, contentId, contentSource } = useAnalyticsPageView();
  const { deployableName, deployableVersion, analytics, deviceId } = useAnalytics();
  const { isLoggedIn } = useIdentity();

  if (isLoggedIn) return null;

  const onClick = async () => {
    const currentURL = new URL(getCleanLocationHref());
    const urlWithoutSearchParams = `${currentURL.origin}${currentURL.pathname}`;
    const anonymousUserId = (await analytics?.segmentInstance?.user())?.anonymousId() || '';

    auth0.signUp({
      anonymousUserId,
      cancelUrl: urlWithoutSearchParams,
      deployableName,
      deployableVersion,
      driverContentId: String(contentId),
      driverContentSource: contentSource || '',
      driverElement: 'button',
      driverLocation: 'AuthLink',
      driverPageName: pageName || window.location.pathname,
      driverPageUrl: urlWithoutSearchParams,
      driverPageViewId: pageViewId,
      driverSubLocation: '',
      redirectTo: urlWithoutSearchParams,
      mostRecentTraditionalDeviceId: deviceId,
    });
  };

  return (
    <section className="mb-16 flex flex-col items-start gap-4 border border-border bg-[var(--content-yellow-lightest)] px-4 py-4 sm:flex-row sm:items-center sm:gap-7 sm:px-7 md:gap-9">
      {/* Stage parity: body 1.5 and CTA 1.2/.11rem; packages/ui/src/reviews/investing/SignUpBanner/index.tsx:57-65, Theme/index.ts:518. */}
      <div>
        <p className="typography-text-bold mb-2 font-bold">
          Get more smart money moves — straight to your inbox
        </p>
        <p className="typography-text-small leading-normal">
          Become a NerdWallet member, and we&apos;ll send you tailored articles we think you&apos;ll
          love.
        </p>
      </div>
      <Button
        className="h-[45px] w-[155px] text-sm leading-[1.2] tracking-[.11rem] sm:w-[200px]"
        fullWidth={false}
        onClick={onClick}
      >
        Sign up now
      </Button>
    </section>
  );
}
